import React, { useState } from "react";
import Dropdown from "../assets/images/icons/arrow-down.svg"; // Import arrow for select

const DESCRIPTION_MAX_LENGTH = 1000;

// `reasons` are the live report categories from the API ({ code, label }); `onSubmit` resolves when the report is saved
const ReportStreamModal = ({ isOpen, onClose, onSubmit, logo, closeIcon, reasons = [] }) => {
  const [reason, setReason] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleClose = () => {
    setReason("");
    setDescription("");
    setError("");
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!reason) {
      setError("Please select a reason.");
      return;
    }
    setError("");
    setSubmitting(true);
    try {
      await onSubmit({ reason, description: description.trim() });
      handleClose();
    } catch (err) {
      setError(err.message || "Unable to submit the report.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="get-verified popup-share fixed inset-0 flex items-center justify-center bg-[#000] bg-opacity-60 w-full backdrop-blur-md z-50">
        <div className="border-popup bg-white rounded-3xl relative w-full max-w-6xl mx-4 overflow-hidden shadow-2xl">
          {/* Header */}
          <div className="flex justify-between items-start p-10 pb-0">
            {/* Logo Section */}
            <div className="logo-popup flex items-center justify-center">
              <img src={logo} alt="Nyawoo Logo" className="w-[150px]" />
            </div>
            {/* Close Button */}
            <button
              onClick={handleClose}
              className="hover:opacity-80 transition-opacity"
            >
              <img src={closeIcon} alt="close" className="w-10 h-10" />
            </button>
          </div>

          <div className="p-10 pt-5">
            <div className="mb-8">
              <h2 className="text-3xl font-bold text-[#BE1F2E] mb-2">
                Report Live Stream
              </h2>
              <p className="text-sm text-black font-medium">
                Help us understand what's going wrong with this live session.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-8">
              {/* Reason Dropdown */}
              <div>
                <label className="block text-sm font-bold text-black mb-3">
                  Why are you reporting this live stream?
                </label>
                <div className="relative">
                  <select
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    className={`w-full h-14 px-4 rounded-xl border border-[#095228] appearance-none focus:outline-none bg-white cursor-pointer text-sm ${
                      reason === "" ? "text-gray-400" : "text-black"
                    }`}
                  >
                    <option value="" disabled hidden>
                      Select a Reason
                    </option>
                    {reasons.map(({ code, label }) => (
                      <option key={code} value={code}>
                        {label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-4 flex items-center pointer-events-none">
                    <img src={Dropdown} alt="" className="w-4 h-4" />
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-bold text-black mb-3">
                  Describe the issue (optional):
                </label>
                <textarea
                  rows="4"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  maxLength={DESCRIPTION_MAX_LENGTH}
                  placeholder="Please share specific details to help us review faster."
                  className="w-full px-4 py-3 rounded-xl border border-[#095228] resize-none focus:outline-none text-sm"
                />
                {error && (
                  <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>
                )}
              </div>

              {/* Submit Button */}
              <div className="pt-4">
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-[#BE1F2E] text-white px-10 h-14 rounded-full hover:bg-red-700 transition shadow-md font-bold text-base disabled:opacity-60"
                >
                  {submitting ? "Submitting..." : "Submit Report"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportStreamModal;
